import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const StyledMuiButton = withStyles({
  root: {
    borderRadius: 4,
    textTransform: 'none',
    fontWeight: 600,
    padding: '4px 14px',
    // твої кольори
    '&.MuiButton-contained': {
      backgroundColor: '#E68200',

      color: '#fff',
      '&:hover': {
        backgroundColor: '#B35600',
      },
    },
    '&.MuiButton-outlined': {
      borderColor: '#B35600',
      color: '#E68200',
      '&:hover': {
        backgroundColor: 'rgba(230,130,0,0.08)',
      }
    }
  }
})(Button);

export default StyledMuiButton;
